import React from 'react';
import RaContent from 'components/admin/manage/edd/ra/RaContent';

export const RaPage = () => {
  return <RaContent />;
};
